export default __webpack_public_path__ + "static/media/mobile-tour-diagnosis-img.87fc82cd.svg";